import Bluebird from 'bluebird';
import CacheG from '../../../../../../services/cache';
import { apiCall } from '../../../../services/api';
import { storePlace, storeTransport } from '../../quote-data';

const cache = new CacheG<API.ApiLocation[]>();

export default function searchLocation(query: string): Bluebird<API.ApiLocation[]> {
    // Validate query
    if (!(query = query.trim())) {
        return Bluebird.reject(new TypeError('Provided query was empty'));
    }

    // Check cache
    const cached = cache.find(query);
    if (cached) return Bluebird.resolve(cached);

    // Fetch results from API
    return apiCall<API.LocationsResponse>('GET', 'locations/search', { searchString: query })
        .then(x => {
            cache.set(query, x.data);

            x.data.forEach(loc => {
                if (loc.type === 'Place') {
                    storePlace(loc.id, { name: loc.name });
                } else {
                    storeTransport(loc.id, { name: loc.name });
                }
            });

            return x.data;
        });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/input-fields/unibar/location-search.ts